/**
 * Step 4 — MyVIP Profile Submission (Conditional)
 *
 * Only rendered if formData.parking_program === 'myvip'.
 * Multi-file upload (CSV/Excel). Submit triggers audit generation.
 */
import React, { useState } from 'react';
import { api } from '../../../api';
import ParsedPreviewCard from './ParsedPreviewCard';

export default function Step4MyVIP({ draftId, formData, onChange, onSubmit, onBack, files, refreshFiles }) {
  const [uploading, setUploading] = useState(false);
  const [parsing, setParsing] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [preview, setPreview] = useState(formData?.myvip_summary || null);

  const existing = (files || []).filter(f => f.file_kind === 'myvip');

  const handleUpload = async (e) => {
    const fl = e.target.files;
    if (!fl || !fl.length) return;
    setUploading(true);
    setError('');
    try {
      await api.uploadAuditFiles(draftId, 'myvip', Array.from(fl));
      await refreshFiles();
      setParsing(true);
      const res = await api.parseAuditMyVIP(draftId);
      setPreview(res.summary);
      onChange({ ...formData, myvip_summary: res.summary });
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
      setParsing(false);
    }
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    setError('');
    try {
      await onSubmit();
    } catch (err) {
      setError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <div className="audit-step audit-step-4">
      <h2>MyVIP Profiles</h2>
      <p className="audit-step-help">
        Upload your MyVIP profile export(s). We'll cross-reference units against the rent roll.
      </p>

      <label className="audit-uploader">
        <input
          type="file"
          accept=".csv,.xlsx,.xls"
          multiple
          onChange={handleUpload}
          disabled={uploading || parsing || submitting}
        />
        <span>
          {uploading ? 'Uploading…' : parsing ? 'Parsing…' : 'Add MyVIP file(s)'}
        </span>
      </label>

      {existing.length > 0 && (
        <ul className="audit-file-list">
          {existing.map(f => (
            <li key={f.id}>
              <span>{f.original_filename}</span>
              <small>{Math.round(f.size_bytes / 1024)} KB</small>
            </li>
          ))}
        </ul>
      )}

      {preview && <ParsedPreviewCard summary={preview} kind="myvip" onConfirm={() => {}} onReupload={() => setPreview(null)} />}

      {error && <div className="audit-error">{error}</div>}

      <div className="audit-step-actions">
        <button type="button" className="audit-btn ghost" onClick={onBack} disabled={submitting}>← Back</button>
        <button
          type="button"
          className="audit-btn primary"
          onClick={handleSubmit}
          disabled={submitting || !existing.length}
        >
          {submitting ? 'Generating…' : 'Submit & Generate Audit'}
        </button>
      </div>
    </div>
  );
}
